import "jQuery";
import {getScrollBarWidth} from './utils';
import {breakpoints} from './responsive';

'use strict';

(function($) {

    function initFooter() {
        $('.site-footer').each(function() {
            let footer_height = $(this).outerHeight();
            $('.site-content').css('margin-bottom', footer_height + 'px');
        });
    }

    $(window).load(function() {
        initFooter();
    });
})( jQuery );